import styled from 'styled-components'
import Paper from '@mui/material/Paper'
import Button from '@mui/material/Button'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
`

export const Row = styled.div`
  display: flex;
  flex-direction: row;
`

export const Box = styled(Paper)`
  padding: 20px 16px;
`

export const Text = styled.span`
  display: block;
  margin-bottom: 30px;
  padding-left: 12px;
  color: #202020;
  letter-spacing: 0.15px;
`



export const CenteredButton = styled(Button)`
  &.MuiButtonBase-root {
    width: 36%;
    margin: auto;
  }
`
